import { Stack } from '@mui/material';
import {
  HeaderBreadcrumbs,
  ScreenError,
  ScreenWrap,
  SoloLoading,
} from '../../components';
import ClinicianForm from './ClinicianForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditClinicianScreen() {
  const { id } = useParams();

  const api = Api.User.useReadItem(id!);

  const foundersApi = Api.User.useReadCollectionClinicians({
    'clinicianProfile.type': 'founder',
  });

  if (api.error) return <ScreenError {...api} />;
  if (foundersApi.error) return <ScreenError {...foundersApi} />;
  if (!api.data || !foundersApi.data) return <SoloLoading />;

  const founderExists = foundersApi.data.member.some((c) => c.id !== id);

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Edit Clinician"
          items={[{ name: 'Clinicians', url: '/clinicians' }]}
        />

        <ClinicianForm existing={api.data} founderExists={founderExists} />
      </Stack>
    </ScreenWrap>
  );
}
